import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    onClick: _ctx.toggleMobileMenu,
    class: "trigger-menu",
    rounded: "0",
    variant: "text",
    "aria-label": "Menu",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    "aria-controls": "menuList",
    title: "Menu"
  }, {
    default: _withCtx(() => [
      (!_ctx.showMobileMenu)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            size: "35"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("mdi-information-variant")
            ])),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            size: "35"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("mdi-close")
            ])),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["onClick"]))
}